<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white active">Contact us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- Google Map Section Start-->
        <div class="section p-0">
            <div class="google-map">
                <iframe src="https://maps.google.com/maps?q=manhatan&t=&z=13&ie=UTF8&iwloc=&output=embed" width="500" height="400" allowfullscreen></iframe>
            </div>
        </div>
        <!-- Google Map Section End-->
        <section class="section section-contactus">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1.5s">
                        <form class="contact_form">
                            <h1 class="font-weight-bold section-h1">Contact Us</h1>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="name" id="name" type="text" class="form-control" placeholder="Full name...">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="email" id="email" type="email" class="form-control" placeholder="Your email...">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <input name="subject" id="subject" type="text" class="form-control" placeholder="Your subject...">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <textarea name="comments" id="comments" rows="4" class="form-control" placeholder="Your message..."></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <input type="submit" class="btn btn-gradient text-white w-100 text-uppercase" value="Send Message">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1.5s">
                        <div class="contact-sm-mt">
                            <h4 class="font-weight-bold">Our Office</h4>
                            <ul class="contact-menu-list list-unstyled">
                                <li class="py-2 align-items-center">
                                    <i class="cont-icon mdi mdi-map-marker"></i>
                                    <strong class="text-dark"> Address:</strong>555 NOrth Orchard Street Kings Mountain,28086
                                </li>
                                <li class="py-2 align-items-center">
                                    <i class="cont-icon mdi mdi-phone"></i>
                                    <strong class="text-dark"> Phone: </strong>(123) 456-789
                                </li>
                                <li class="py-2 align-items-center">
                                    <i class="cont-icon mdi mdi-email"></i>
                                    <strong class="text-dark"> Email: </strong>
                                    <a href="info@yourdomain.com"> info@yourdomain.com </a>
                                </li>
                            </ul>
                        </div>

                        <div class="pt-2">
                            <h4 class="font-weight-bold">Business Hours</h4>
                            <ul class="business-hrs-list list-unstyled">
                                <li class="py-2"><i class="mdi mdi-clock-outline"></i> Monday - Friday - 9am to 5pm</li>
                                <li class="py-2"><i class="mdi mdi-clock-outline"></i> Saturday - 9am to 2pm</li>
                                <li class="py-2"><i class="mdi mdi-clock-outline"></i> Sunday - Closed</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: "contact",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            }

        }
    }</script>
